import axios from 'axios'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const useDeptWiseDesignation = () => {
    const loginUserData = useSelector((state) => state.loginData.userData);
    // Changed state name properly
    const [designationOptions, setDesignationOptions] = useState([])

    useEffect(() => {

        const fetchDesignationByDepartment = async () => {
            try {

                const res = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/emp/getAlldesignationDept`,
                    {
                        departmentName: loginUserData?.departmentName
                    }
                )

                const formattedData =
                    res?.data?.data?.length > 0
                        ? res.data.data.map((item) => ({
                            value: item._id,
                            label: item.empDesignation
                        }))
                        : []

                setDesignationOptions(formattedData)

            } catch (error) {
                console.log("Error fetching designation:", error)
                setDesignationOptions([])
            }
        }

        fetchDesignationByDepartment()

    }, [])

    return { designationOptions }
}

export default useDeptWiseDesignation